import { toMoney as VMaskerToMoney } from "vanilla-masker";

const toMoneyTyping = (value, opts) => {

  // Set default options, new options override them
  opts = {
    precision: 2,
    separator: '.',
    delimiter: ',',
    ...opts
  };

  return VMaskerToMoney(value, opts);
};

const toMoney = (value, opts) => {

  // Set default options, new options override them
  opts = {
    precision: 2,
    separator: '.',
    delimiter: ',',
    ...opts
  };

  // If value is null, undefined, or NaN, set it to 0
  if (value === null || value === undefined || isNaN(parseFloat(String(value).replaceAll(opts.delimiter, '')))) {
    value = 0;
  }

  // If value is 0, return "0.00"
  if (parseFloat(value) === 0) {
    if(opts.precision == 0) return "0";
    if(opts.precision >= 1) return `0.${String('0').repeat(opts.precision)}`;
  }

  // Convert the value to a string
  value = String(value);

  if(opts.precision >= 1)
  {
    // Split the string into integer and decimal parts
    let parts = value.split(opts.separator);
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? parts[1] : '';

    if(opts.precision >= 1)
      decimalPart = opts.separator + decimalPart.padEnd(opts.precision, '0');

    // Add grouping to the integer part
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, opts.delimiter);

    // Concatenate integer and decimal parts and return
    return integerPart + decimalPart;
  }
  else
  {
    let integerPart = value.replace(opts.separator, '');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, opts.delimiter);
    return integerPart;
  }

};

export { toMoneyTyping, toMoney };
